import React from 'react';
import aboutimg from '../../images/aboutimgt.jpg'

const ServiceAbout = () => {
    return (
            <div className="w-full bg-base-200 flex flex-col lg:flex-row p-2">
                <div className='w-full lg:w-3/5'>
                    <img src={aboutimg} className="rounded-lg shadow-2xl" alt='' />
                </div>
                <div className='w-full lg:w-2/5 p-5'>
                    <h1 className="text-3xl lg:text-5xl font-bold">My Services about</h1>
                    <p className="py-6 text-lg font-semibold">I am professional PhotoGraper !!! My experience of 10 years.If you need ? You can Hair me</p>

                    <div className="bg-base-100 rounded-md grid md:grid-cols-2 lg:grid-cols-3 ">
                        <div className="stat">
                            <div className="stat-title">Total Orders</div>
                            <div className="stat-value">31K</div>
                            <div className="stat-desc">Jan 1st - Dec 1st</div>
                        </div>

                        <div className="stat">
                            <div className="stat-title">Pending</div>
                            <div className="stat-value">4,200</div>
                            <div className="stat-desc">↗︎ 400 (22%)</div>
                        </div>

                        <div className="stat">
                            <div className="stat-title">Reviews</div>
                            <div className="stat-value">1,200</div>
                            <div className="rating gap-1">
                                <input type="radio" name="rating-3" className="mask mask-heart bg-red-500"  />
                                <input type="radio" name="rating-3" className="mask mask-heart bg-red-500"  />
                                <input type="radio" name="rating-3" className="mask mask-heart bg-red-500"  />
                                <input type="radio" name="rating-3" className="mask mask-heart bg-red-500"  />
                                <input type="radio" name="rating-3" className="mask mask-heart bg-lime-500"  />
                            </div>
                        </div>

                    </div>

                </div>
            </div>
    );
};

export default ServiceAbout;